// removed by extract-text-webpack-plugin
module.exports = {"programLink":"_2vioTQdr3wBpVI6MwGluDR","programIcon":"_1i7_abV_4fogzbvZwaboGP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/ProgramSearchResult.css
// module id = 1375
// module chunks = 0